var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeCreek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.5,190.44s52.46.77,84.86-15.43c0,0,23.92-10.8-12.34-11.57,0,0-44,3.08,2.31-18.52,0,0,27-12.35,54.78-17M46.86,170.37H97.13M72.29,26.88S124,87.82,112.41,117.15c0,0-8.49,28.54-42.43,29.31,0,0-40.12-3.09-38.57-43.2C31.41,103.26,36.81,69.31,72.29,26.88ZM57.63,120.23l13.12,13.12m1.54-16.2,11.58-10.8M71.52,169.61V104"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeCreek);
export default __webpack_public_path__ + "static/media/TREE_CREEK.87a6e841df3ed25ba6a02f1a7acd1d09.svg";
export { ForwardRef as ReactComponent };